import { useEffect } from 'react';
import { scheduleToastDismiss } from '@/shared/effects/scheduleToastDismiss';

export function useToastAutoDismiss(message: string, onDismiss: () => void): void {
  useEffect((): (() => void) => {
    return scheduleToastDismiss({ message, onDismiss });
    // Callers pass a fresh onDismiss every render; restarting the timer on each of those would keep the toast up indefinitely.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);
}
